import { Dropdown, IDropdownOption, Separator } from '@fluentui/react';

import banks from '../../../../../shared/banks.json';
import paymentTypes from '../../../../../shared/payment-types.json';
import { Payment } from '../../../slice/newFormReducers';
import { useColumnOnChangeFn, useColumnSelector } from './hooks';

type Props = {
  uuid: string;
};

const key: keyof Payment = "bankId";

export default ({ uuid }: Props) => {
  const paymentType = useColumnSelector(uuid, "type");
  const paymentTypeInfo = paymentTypes.find((t) => t.type === paymentType);

  const isEditingLocked = useColumnSelector(uuid, "isEditingLocked");
  const value = useColumnSelector(uuid, key);
  const onChange = useColumnOnChangeFn(uuid, key);

  if (!paymentTypeInfo?.banks) {
    return <Separator />;
  }

  return (
    <Dropdown
      selectedKey={value ? value.toString() : ""}
      onChange={onChange}
      options={
        paymentTypeInfo?.banks === "all" ? allOptions : registeredOptions
      }
      disabled={isEditingLocked}
    />
  );
};

const map = (bank: typeof banks[0]): IDropdownOption => ({
  key: bank.id,
  text: bank.name,
});
const registeredOptions = banks.filter((b) => b.isRegistered).map(map);
const allOptions = banks.map(map);
